import React, { Component } from 'react';
import {MDBDataTable} from "mdbreact";
import {Card, CardHeader, Row, Col} from 'reactstrap';
import {Dropdown, Button, Checkbox, Icon, Rating} from "semantic-ui-react";
import * as common from "../../../../../../const/Common/CommonFunc";
import axios_eventtag from "../../../../../../axios/axios_eventtag";
import apiConfig from "../../../../../../axios/axios_api_services";
import Cookies from "js-cookie";
import {connect} from "react-redux";
import * as actionCreator from "../../../../../../store/Action";
import './Style.scss';

class sessionFeedback extends Component {
    state = {

        questions: [],
        event_list: [],
        eventSubEvents: [],
        subEventSessions: [],
        sessionSpeakerList: [],

        eventId: '',
        sessionId: '',
        startDate: '',
        endDate: '',
        subEventId: '',
        speakerId: '',
        feedbacks : [],
        avgRate: 0.0
      };

      getEvents = (status) => {
        this.props.spinnerHandler(true);
        const headers = {
          "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
        };

        let corperateId = this.props.usr_obj.corporates[0].corporateId;
        axios_eventtag.get(apiConfig.CORPORATE_EVENTS({corporateId: corperateId}), {headers: headers})
          .then(async response => {
            this.props.spinnerHandler(false);

            if (response.data.success) {
              this.setState({event_list: response.data.eventList});
              if(status === "ON_LOAD"){
                let firstEventId = response.data.eventList.length !== 0 ? response.data.eventList[0].event_id : '';
                this.setState({
                  eventId: firstEventId
                });
                this.getSubEvents(null, {value: firstEventId})
              }
            }
          })
          .catch(async error => {
            this.props.spinnerHandler(false);
            let result = await common.checkErrorResponse(error);
            if (result === 1) {
              this.getEvents(status);
            } else {
              this.props.spinnerHandler(false)
            }
          })
          .finally(fin => {
          });
      };
      dropdownOnchange = name => (e, {value}) => {
        this.setState({
          // subEventId: name === 'sessionId' ? this.state.subEventId : '',
          // sessionId: '',
          feedbacks: [],
          [name]: value,
        });

        switch (name) {
          case "eventId":
            this.setState({
              subEventId: '',
              sessionId: '',
              speakerId: '',
              eventSubEvents: [],
              subEventSessions: [],
              sessionSpeakerList: []
            });
            this.getSubEvents(e, {value});
            break;
          case "subEventId":
            this.setState({
              sessionId: '',
              speakerId: '',
              subEventSessions: [],
              sessionSpeakerList: []
            });
            this.getSessions(e, {value});
            break;
          case "sessionId":
            this.setState({
              speakerId: '',
              sessionSpeakerList: []
            });
            this.getAllSpeakerList(e, {value});
            break;
          case "speakerId":
            this.getAllSpeakerFeedbacks(e, {value});
            break;
          default:
            break;
        }
      };


      getAllSpeakerList = (e, {value}) => {
        this.props.spinnerHandler(true);

        let corporateId = this.props.usr_obj.corporates[0].corporateId;

        const headers = {
          "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
        };
        axios_eventtag.get(apiConfig.GET_SESSION_SPEAKER_LIST({session_id: value, corporateId: corporateId}),
          {headers: headers})
          .then(response => {

            this.props.spinnerHandler(false);

            if (response.data.success) {
              this.setState({
                sessionSpeakerList: response.data.content,
                feedbacks : []
              });

            } else {
              this.setState({
                eventSubEvents: []
              })
            }
          })
          .catch(async error => {
            this.props.spinnerHandler(false);

            let result = await common.checkErrorResponse(error);
            if (result === 1) {
              this.getAllSpeakerList(e, {value});
            }
          })
          .finally(fin => {
          });
      };


      getAllSpeakerFeedbacks = (e, {value}) => {
          // this.setState({
          //     feedbacks : this.props.speaker_feedbacks
          // })
          this.props.spinnerHandler(true);

        let corporateId = this.props.usr_obj.corporates[0].corporateId;

        const headers = {
          "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
        };
        axios_eventtag.get(apiConfig.GET_ALL_SPEAKER_FEEDBACKS({session_id: this.state.sessionId, speaker_profile_id: value, corporateId: corporateId}), {headers: headers})
          .then(response => {
            this.props.spinnerHandler(false);
            if (response.data.success) {
              this.setState({
                feedbacks : response.data.content.speakerFeedbackList,
                avgRate: response.data.content.avgRate
              });

            } else {
              this.setState({
                feedbacks: []
              })
            }
          })
          .catch(async error => {
            let result = await common.checkErrorResponse(error);
            if (result === 1) {
              this.getAllSpeakerFeedbacks(e, {value});
            }
          })
          .finally(fin => {
            this.props.spinnerHandler(false);
          });
      }

      getSubEvents = (e, {value}) => {

        this.props.spinnerHandler(true);

        let corporateId = this.props.usr_obj.corporates[0].corporateId;

        const headers = {
          "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
        };
        axios_eventtag.get(apiConfig.GET_ALL_SUB_EVENT({event_id: value, corporateId: corporateId}), {headers: headers})
          .then(response => {

            this.props.spinnerHandler(false);

            if (response.data.success) {
              this.setState({
                eventSubEvents: response.data.subEventList,
                feedbacks : []
              });
              if(e === null){
                let firstSubeventId = response.data.subEventList.length !== 0 ? response.data.subEventList[0].sub_event_id : '';
                this.setState({subEventId: firstSubeventId});
                // this.getSessions(null, {value: firstSubeventId});
              }

            } else {
              this.setState({
                eventSubEvents: []
              })
            }
          })
          .catch(async error => {
            this.props.spinnerHandler(false);

            let result = await common.checkErrorResponse(error);
            if (result === 1) {
              this.getSubEvents(e, {value});
            }
          })
          .finally(fin => {
          });
      };

      getSessions = (e, {value}) => {
        this.props.spinnerHandler(true);

        let corporateId = this.props.usr_obj.corporates[0].corporateId;

        const headers = {
          "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
        };
        axios_eventtag.get(apiConfig.GET_SUB_EVENT_SESSIONS({sub_event_id: value, corporateId: corporateId}), {headers: headers})
          .then(response => {
            this.props.spinnerHandler(false);

            if (response.data.success) {
              this.setState({
                subEventSessions: response.data.sessionList,
                feedbacks : []
              });
              // if(e === null){
              //   let firstSessionId = response.data.sessionList.length !== 0 ? response.data.sessionList[0].session_id : '';
              //   this.setState({sessionId: firstSessionId});
              //   // this.getAllSpeakerFeedbacks(null, {value: firstSessionId})
              // }
            } else {
              this.setState({subEventSessions: []})
            }
          })
          .catch(async error => {

            let result = await common.checkErrorResponse(error);
            if (result === 1) {
              this.getSessions(e, {value});
            } else {
              this.props.spinnerHandler(false)
            }
          })
          .finally(fin => {
            this.props.spinnerHandler(false);
          });
      };

    componentDidMount() {
        this.getEvents("ON_LOAD_");
    }

    render() {
        let elist = [];
        if (this.state.event_list !== null) {
          this.state.event_list.map((value, index) => {
            elist.push({
              text: value.event_name,
              value: value.event_id,
              key: value.event_id
            })
          })
        }

        let subEventList = [];

        if (this.state.eventSubEvents.length !== 0) {
          this.state.eventSubEvents.map((value, index) => {
            subEventList.push({
              text: value.name,
              value: value.sub_event_id,
              key: value.sub_event_id
            });
          });
        }

        let sessions = [];
        if (this.state.subEventSessions.length !== 0) {
          this.state.subEventSessions.map((value, index) => {
            sessions.push({
              text: value.name,
              value: value.session_id,
              key: value.session_id
            })
          })
        }

      let speakers = [];
      if (this.state.sessionSpeakerList.length !== 0) {
        this.state.sessionSpeakerList.map((value, index) => {
          speakers.push({
            text: value.name,
            value: value.speaker_profile_id,
            key: value.speaker_profile_id
          })
        })
      }

        let columns = this.props.table_data.columns
        let rows = [];

        if(this.state.feedbacks.length !== 0) {
            this.state.feedbacks.map((response, index) => {
                rows.push({
                    speaker_name : response.speaker_profile_name,
                    participant_name: response.participant_name,
                    feedback : response.feedback,
                    rating :  <div style={{paddingTop: '5px'}}>
                                    <Rating disabled={true} maxRating={5} defaultRating={response.rate} icon='star' size='huge'/>
                            </div>
                })
            })
        }

        return (
        <div className="event-org-speaker-feedback">
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card className="card1">
              <CardHeader>
                Filter Events
              </CardHeader>
              <Col lg={12}>
                <Row className={"search-event-row"}>
                  <Col lg={3} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Event'
                      fluid
                      selection search
                      options={elist}
                      value={this.state.eventId}
                      onChange={this.dropdownOnchange("eventId")}
                    />
                  </Col>
                  <Col lg={3} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Sub Event'
                      fluid
                      selection search
                      options={subEventList}
                      value={this.state.subEventId}
                      onChange={this.dropdownOnchange("subEventId")}
                    />
                  </Col>
                  <Col lg={3} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Session'
                      fluid search
                      value={this.state.sessionId}
                      selection
                      options={sessions}
                      onChange={this.dropdownOnchange("sessionId")}
                    />
                  </Col>
                  <Col lg={3} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Speaker'
                      fluid search
                      value={this.state.speakerId}
                      selection
                      options={speakers}
                      onChange={this.dropdownOnchange("speakerId")}
                    />
                  </Col>
                </Row>
              </Col>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card className="card1">
              <CardHeader>
                Feedbacks for the Speaker
              </CardHeader>
              <Col lg={"12"}>
                {
                  this.state.feedbacks.length !== 0 ?
                    <Row>
                      <Col xs="12" lg={"12"} md={"12"} className={'avg-rate'}>
                        <h3>
                          Average Rating: <h1 className={'f-weight'}>{this.state.avgRate.toFixed(1)}</h1>
                        </h3>
                        <Rating disabled={true} maxRating={5} defaultRating={this.state.avgRate} icon='star' size='small'/>
                      </Col>
                    </Row> : ""
                }


                <Row className={"search-event-row"}>
                  <Col lg={"12"} md={"12"}>
                    <MDBDataTable
                      className={ "tbl-event-speaker-feedback" }
                      striped
                      searching={true}
                      displayEntries={true}
                      bordered
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      hover
                      // className={"table thead th"}
                      // columns={columns}
                      // rows={rows}

                      data={{
                        rows: rows,
                        columns: columns
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Card>
          </Col>
        </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    usr_obj: state.userReducer.user,
    table_data: state.feedbackReducer.speaker_feedback_table,
    speaker_feedbacks: state.feedbackReducer.speaker_feedback_Array
  });

const mapDispatchToProps = (dispatch) => {
    return {
      // spinner handler
      spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
      // all available cards
      receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data)),

    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(sessionFeedback);
